import FingoPaper from '@fingo/lib/components/layout/FingoPaper';
import React from 'react';
import { collectionTabs } from '../../../routes/sales';

const CollectionDebtorsView = () => {
  const tabs = collectionTabs();
  return <FingoPaper tabs={tabs} />;
};

export default CollectionDebtorsView;
